import Act from "../actions";

const initState = {
  // 存放 OCR 原始資料
  ocrOriginalData: [],
  // 存放 OCR 編輯後資料
  ocrImgList: [],
  pagination: {
    activePage: 0,
    totalPage: 0,
  },
  uploadOcrStatus: false, // OCR 上傳檔案的狀態
  ocrStatus: false, // 執行 OCR 狀態
  fileName: null, // OCR 上傳檔名
  finishOCR: false, // OCR 完成
  ocrErrorCount: null, // 執行過 ocr 但失敗的數量,
  uploadErrorMsg: {
    id: "sna.sidetool.digitalAITool.ocr.uploading.error",
    defaultMsg: "The file exceeds 10MB, please upload the file again.",
  },
};

const digitalAIReducer = (state = initState, action) => {
  switch (action.type) {
    case Act.DIGITAL_AI_SET_IMG_LIST:
      return {
        ...state,
        ocrImgList: action.payload,
      };
    case Act.SNA_SET_OCR_ORIGINAL_DATA:
      return {
        ...state,
        ocrOriginalData: action.payload,
      };
    case Act.DIGITAL_AI_SET_ACTIVE_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          activePage: action.payload,
        },
      };
    case Act.DIGITAL_AI_SET_TOTAL_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          totalPage: action.payload,
        },
      };
    case Act.DIGITAL_AI_SET_UPLOAD_OCR_FILES_STATUS:
      return {
        ...state,
        uploadOcrStatus: action.payload,
      };
    case Act.DIGITAL_AI_SET_OCR_STATUS:
      return {
        ...state,
        ocrStatus: action.payload,
      };
    case Act.DIGITAL_AI_SET_OCR_FILE_NAME:
      return {
        ...state,
        fileName: action.payload,
      };
    case Act.DIGITAL_AI_INIT:
      return {
        ...state,
        ocrImgList: [],
        pagination: {
          activePage: 0,
          totalPage: 0,
        },
        fileName: null, // OCR 上傳檔名
        finishOCR: false,
        ocrErrorCount: null,
      };
    case Act.DIGITAL_AI_SET_OCR_FINISH:
      return {
        ...state,
        finishOCR: action.payload,
      };
    case Act.DIGITAL_OCR_ERROR_COUNT:
      return {
        ...state,
        ocrErrorCount: action.payload,
      };
    case Act.DIGITAL_OCR_UPLOAD_ERROR:
      return {
        ...state,
        uploadErrorMsg: action.payload,
      };
    default:
      return state;
  }
};
export default digitalAIReducer;
